import { IRate } from 'apps/marketplace/store/contractLanes/types'
import { ReducerActions } from '../reducers/contractLaneModal'

export const showContractLane = (carrierContractLane: IRate) => {
  return { type: ReducerActions.show, currentContract: carrierContractLane }
}
